export default "__VITE_ASSET__b60dca95__"